import { generateRoute } from '@klpkonsern/routing';
import { generateApiRoute } from '@klp/core/api/helpers';
import type { ExpiryType } from './classes/ExpiryType';

const portfolioApiName = 'portfolio';

export const FrontpageModuleName = '/';

export const FrontpageRoutes = {
    frontpage: () => generateRoute([FrontpageModuleName]),
};

export const FrontpageApiRoutes = {
    aggregates: () => generateApiRoute([portfolioApiName, 'aggregater']),
};

declare global {
    interface AppConfigParameters {
        WEBAPP_CONTRACT_FRAME_URL: string;
    }
}

declare global {
    interface IAppParams {
        storedSelectedExpiryType?: ExpiryType;
    }
}
